import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid, getParam} from '../question-helper';
import {QuestionType} from '../../constants';
import {GlobalQuestionService} from '../../services/global-question.service';
import {Subject} from 'rxjs';
import {debounceTime} from 'rxjs/operators';

@Component({
    selector: 'app-question-generic-parent-stacked',
    templateUrl: './question-generic-parent-stacked.component.html',
    styleUrls: ['./question-generic-parent-stacked.component.scss'],
    standalone: false
})
export class QuestionGenericParentStackedComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

  @Input() question: Question;
  @Input() isPercentage = false;
  @Input() itemQuestions: Question[] = [];
  @Output() questionAnswer = new EventEmitter<any>();
  @Output() enableButtonFromChild = new EventEmitter<boolean>();
  @Output() childTypePresence = new EventEmitter<{ parentQuestionId: number; hasRemoveQuestionPanel: boolean }>();

  childrenQuestions: Question[] = [];
  uniqueId = `label-textbox-parent-${newGuid()}`;
  QuestionType = QuestionType;
  total = 0;
  questionChanged = new Subject<Question>();
  parameters: any[] = [];
  processing = false;
  premium = 0;
  hidePrem = false;
  showLabel = false;
  constructor(private questionService: GlobalQuestionService) {
  }

  ngOnInit(): void {
    let param = JSON.parse(this.question.parameter);
    if (param?.length){
      this.hidePrem = getParam(param, 'hide_prem')?.value === '1';
      this.showLabel = getParam(param, 'showLabel')?.value === '1';
    }
    
    this.questionChanged.pipe(
      debounceTime(500)
    ).subscribe(x => {
      if (x) {
        this.saveAnswer(x);
      }
    });
  }

  ngAfterViewInit(): void {
    console.log(this.childrenQuestions)
    if (this.childrenQuestions.every(q => q.answer)) {
      //console.log("completed");
      //this.enableButtonFromChild.emit(false);
    }
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    
    if (changes?.question?.currentValue) {
      this.question = changes?.question?.currentValue;
      if (this.question) {
        if (this.question?.parameter) {
          this.parameters = JSON.parse(this.question?.parameter);
        }
        this.childrenQuestions = [];
        if (this.itemQuestions?.length) {
          this.childrenQuestions = this.itemQuestions;
          this.emitChildTypePresence();
          
        } else {
          this.getChildrenQuestion();
        }
       
      }
    }
    this.total = 0;
  }

  getChildrenQuestion(): void {
    this.questionService.spinner(true);
    this.questionService.getChildrenQuestions(this.question?.cent_aq_question_id)
      .subscribe((items: Question[]) => {
        this.childrenQuestions = [];
        for (const q of items) {
          if (!this.childrenQuestions.some(c => c.cent_aq_question_id === q.cent_aq_question_id)) {
            this.childrenQuestions.push(Object.assign({}, q));
          }
        }
        this.emitChildTypePresence();
        this.questionService.spinner(false);
      });
  }

  private emitChildTypePresence(): void {
    this.childTypePresence.emit({
      parentQuestionId: this.question?.cent_aq_question_id,
      hasRemoveQuestionPanel: this.childrenQuestions.some(c => this.hasRemoveQuestionPanelParameter(c))
    });
  }

  private hasRemoveQuestionPanelParameter(question: Question): boolean {
    if (!question?.parameter) {
      return false;
    }

    try {
      const parameters = JSON.parse(question.parameter);
      if (!Array.isArray(parameters)) {
        return false;
      }

      return parameters.some((item: any) =>
        item?.parameter === 'removeQuestionPanel' && Number(item?.value) === 1
      );
    } catch {
      return false;
    }
  }

  onChange(value: Question, index: number): void {
    
    this.premium = 0;
    this.childrenQuestions.forEach(element => {
      this.premium += +element.answer;
    });
    
    if (this.childrenQuestions.every(q => q.answer)) {
      this.childrenQuestions.forEach(el => {
        this.saveAnswer(el);
      });
      this.enableButtonFromChild.emit(false);
      this.question.answer = 'Multiple answers';
      this.questionChanged.next(value);
      this.saveAnswer(this.question);
      this.questionAnswer.emit(this.question);
    }
    else {
      this.question.answer = null;
      this.enableButtonFromChild.emit(true);
    }
   
    // this.enableButtonFromChild.emit(false);
    // if (value?.answer) {
    //   this.questionChanged.next(value);
    //   this.childrenQuestions[index] = value;
    //   this.total = 0;
    //   for (const q of this.childrenQuestions) {
    //     if (q?.answer?.includes('|')) {
    //       this.total += +q.answer.split('|')[1];
    //     } else {
    //       this.total += +q.answer;
    //     }
    //   }
  
  }

  saveAnswer(question: Question): void {
    this.processing = true;
    this.questionService.saveAnswerOnly(question).subscribe(val => {
      if (!this.hidePrem) {
        this.questionService.getPremium(question.product_class_id, question?.item_id, question?.product_id, question?.vaps_id)
          .subscribe(prem => {
            if (prem?.length) {
              this.premium = prem[0].premium;
            }
            else {
              this.premium = 0;
            }
            this.processing = false;
          }, error => { this.processing = false });
      }
    });
  }

  ngOnDestroy(): void {
    this.questionChanged.next(undefined as any);
    this.questionChanged.complete();
    this.childrenQuestions = [];
  }

}
